import React from 'react';
import { ContainerBox, FeatureLink, FeatureTitle, FeaturePhoto, FeatureImage } from './ProductFeaturesSectionV2Mob.styles';
import { JoykitIcon } from '@components/JoykitIcon';
import { CloudImage } from '@components/CloudImage';
import { Text } from '@components/typography';
import { useTranslation } from 'react-i18next';

type AssetType = { path: string; className: string; style?: Object; hasFullPath?: boolean };
type Feature = {
  id: string;
  to: string;
  label: string;
  desc: string;
  assets: AssetType[];
};

export const ProductFeaturesSectionV2Mob = () => {
  const { t } = useTranslation('home');

  const featureItems: Feature[] = [
    {
      id: 'home-features-to-wedding-website',
      to: '/wedding-website',
      label: t('sections.features.weddingWebsite.listItemLabel'),
      desc: t('sections.features.weddingWebsite.desc'),
      assets: [{ path: 'wedding-website/ww-mobile.jpg', className: 'featureBackgroundImg', style: {} }],
    },
    {
      id: 'home-features-to-hotel-room-blocks',
      to: '/hotel-room-blocks',
      label: t('sections.features.hotelRoomBlocks.listItemLabel'),
      desc: t('sections.features.hotelRoomBlocks.desc'),
      assets: [{ path: 'travel/room-blocks_static_v2.jpg', className: 'featureBackgroundImg', style: {} }],
    },
    {
      id: 'home-features-to-registry',
      to: '/registry',
      label: t('sections.features.registry.listItemLabel'),
      desc: t('sections.features.registry.desc'),
      assets: [{ path: 'registry/registry-ww.png', className: 'featureBackgroundImg', style: {} }],
    },
    {
      id: 'home-features-to-guest-list',
      to: '/guest-list',
      label: t('sections.features.guestList.listItemLabel'),
      desc: t('sections.features.guestList.desc'),
      assets: [
        { path: 'guest-list/router-gl-bg.jpg', className: 'featureBackgroundImg', style: {} },
        { path: 'guest-list/router-gl-ui-bg.png', className: 'featureUiImg', style: {} },
        { path: t('sections.features.guestList.foregroundSrc'), className: 'featureUiImg', style: {}, hasFullPath: true },
        { path: 'guest-list/router-gl-couple.png', className: 'featureBaseImg', style: {} },
      ],
    },
    {
      id: 'home-features-save-the-dates',
      to: '/save-the-date',
      label: t('sections.features.saveTheDates.listItemLabel'),
      desc: t('sections.features.saveTheDates.desc'),
      assets: [
        { path: 'save-the-dates/router-std-mobile.jpg', className: 'featureBackgroundImg', style: { backgroundPosition: 'center' } },
      ],
    },
    {
      id: 'home-features-to-invitations',
      to: '/wedding-invitations',
      label: t('sections.features.invitations.listItemLabel'),
      desc: t('sections.features.invitations.desc'),
      assets: [
        {
          path: 'invites/invites-mobile.png',
          className: 'featureBackgroundImg',
          style: { backgroundPosition: 'center' },
        },
      ],
    },
    {
      id: 'home-features-to-smart-rsvp',
      to: '/online-rsvp',
      label: t('sections.features.smartRSVP.listItemLabel'),
      desc: t('sections.features.smartRSVP.desc'),
      assets: [
        { path: 'inv-rsvp/router-inv-rsvp-bg.jpg', className: 'featureBackgroundImg', style: {} },
        {
          path: 'inv-rsvp/router-inv-rsvp-card.jpg',
          className: 'featureUiImg',
          style: { maxHeight: '100%', objectFit: 'contain', zIndex: 1 },
        },
        { path: 'inv-rsvp/router-inv-rsvp-ui-bubbles.png', className: 'featureUiImg', style: {} },
        {
          path: 'inv-rsvp/router-inv-rsvp-couple.png',
          className: 'featureBaseImg',
          style: { height: '100%', zIndex: 1 },
        },
      ],
    },
    {
      id: 'home-features-to-guest-app',
      to: '/app',
      label: t('sections.features.guestApp.listItemLabel'),
      desc: t('sections.features.guestApp.desc'),
      assets: [
        { path: 'mobile/router-mobile-bg.jpg', className: 'featureBackgroundImg', style: {} },
        {
          path: 'mobile/router-mobile-couple.png',
          className: 'featureBaseImg',
          style: { height: '100%', objectFit: 'contain', marginTop: '43%' },
        },
        { path: t('sections.features.guestApp.foregroundSrc'), className: 'featureUiImg', style: {}, hasFullPath: true },
      ],
    },
  ];
  return (
    <ContainerBox as="section" id="RoutersMobile">
      {featureItems.map((feature) => {
        const { id, to, label, desc, assets } = feature;
        return (
          <FeatureLink key={label} href={to} id={id}>
            <FeaturePhoto>
              {assets.map((asset: AssetType) => {
                const { path, className, style, hasFullPath } = asset;
                return className === 'featureBackgroundImg' ? (
                  <FeatureImage
                    key={path}
                    className={className}
                    src={hasFullPath ? path : `home/router-sections/router-${path}`}
                    style={style}
                    optimization="default"
                  />
                ) : (
                  <CloudImage
                    alt={path}
                    key={path}
                    className={className}
                    src={hasFullPath ? path : `home/router-sections/router-${path}`}
                    width="100%"
                    optimization="default"
                    style={style}
                  />
                );
              })}
            </FeaturePhoto>
            <FeatureTitle variant="hed40" color="yellow5" tagName="span" textAlign="center">
              {label}
              <JoykitIcon name="rightArrow" color="yellow5" />
            </FeatureTitle>
            <Text variant="featureCopy17" color="yellow6" tagName="span" textAlign="center">
              {desc}
            </Text>
          </FeatureLink>
        );
      })}
    </ContainerBox>
  );
};
